let observer;
let initialized = false; 

function getModifiedHours() {
  let date = new Date();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  let totalSeconds = hours * 3600 + minutes * 60 + seconds;
  let offsetSeconds = totalSeconds - 3 * 3600;
  let modifiedHours =
    (offsetSeconds < 0 ? offsetSeconds + 24 * 3600 : offsetSeconds) / 3600;

  return Math.min(modifiedHours, 22);
}

function getCounterValue() {
  let kgPerDay = 82.19;
  let modifiedHours = getModifiedHours();

  if (modifiedHours >= 22 && modifiedHours < 24) {
    return 82.19;
  }

  return (modifiedHours / 22) * kgPerDay;
}

function updateCounter() {
  let counter = document.getElementById("counter");
  let currentValue = parseFloat(counter.textContent) || 0;
  let targetValue = getCounterValue();

  if (!initialized || currentValue < targetValue) {
    let lerpFactor = 0.1;
    let newValue = currentValue + (targetValue - currentValue) * lerpFactor;
    counter.textContent = newValue.toFixed(2);
    setTimeout(updateCounter, 20);
  } else {
    setTimeout(updateCounter, 1000);
  }
}

let section = document.querySelector(".clean-hub");

observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !initialized) {
        updateCounter();
        initialized = true;
      }
    });
  },
  { threshold: 0.3 }
);

observer.observe(section);